import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "HomeView",
    component: HomeView,
  },
  {
    path: "/list",
    name: "List",
    component: () => import("@/views/List.vue"),
  },
  {
    path: "/tool",
    name: "Tool",
    component: () => import("@/views/Tool.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/configure",
    name: "Configure",
    component: () => import("@/views/Configure.vue"),
  },
];

const router = new VueRouter({
  // mode: "hash",
  mode: "history",
  base: "/",
  routes,
});

export default router;
